import "./Project1.css";

function Project2() {
  return (
    <div className="project1-cont active">
      <div className="project-header">
        <h2>Ray's Portfolio</h2>
      </div>
      <div className="about-text">
        <p>
Ray's project was developed using HTML, CSS/SASS, JavaScript, React, WordPress, and PHP to ensure a flawless and adaptable user experience on different devices. It features a creative custom theme with numerous custom blocks and interactive elements, enhancing the overall visual appeal and user engagement.        </p>
        <h3 className="project-link">
          <a
            href="https://raylutzky.com/"
            target="_blank"
            rel="noreferrer"
          >
            <span>View Site</span>
          </a>
          <br />
        </h3>
      </div>
    </div>
  );
}

export default Project2;
